import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import TaskTile from './TaskTile';

/**
 * Grid component for displaying task tiles
 * @param {Object} props - Component props
 * @param {Array} props.sectionTiles - Array of task tiles to display
 * @param {Function} props.onTileClick - Function to handle tile click
 * @param {Function} props.onMenuOpen - Function to open the menu
 * @returns {React.ReactElement} Tasks grid component
 */
const TasksGrid = ({ sectionTiles, onTileClick, onMenuOpen }) => {
  return (
    <Box sx={{ flex: 1, py: 2, mt: 1 }}>
      <Grid container spacing={5}>
        {sectionTiles.map((tile) => (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={tile.id}>
            <TaskTile
              tile={tile}
              onClick={onTileClick}
              onMenuOpen={onMenuOpen}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

TasksGrid.propTypes = {
  sectionTiles: PropTypes.array.isRequired,
  onTileClick: PropTypes.func.isRequired,
  onMenuOpen: PropTypes.func.isRequired
};

export default React.memo(TasksGrid);
